import { useState, useEffect } from "react";
import { Form, Button, Container, Spinner } from "react-bootstrap";
import instance from "../../services/endpoint";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import Toastify CSS
import img from "../../images/Logo.png";

const AdminForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await instance.post("api/v1/admin/auth/forgetpassword", {
        Email: email,
      });
      toast.success(
        "Password reset link has been successfully sent to your email."
      );
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = "Forgot Password | Bitstek Advisory";
  }, []);

  return (
    <Container
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}>
      {/* <Row>
        <Col xs={12} md={8} lg={6} className="mx-auto"> */}
      {/* Login Box */}
      <div
        className="login-box"
        style={{
          backgroundColor: "#000",
          padding: "30px",
          borderRadius: "8px",
          border: "1px solid #d4af37",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          maxWidth: "400px",
          width: "100%",
          textAlign: "center",
          marginRight: "-115px",
        }}>
        <div className="text-center">
          <img
            src={img}
            alt="Bitstek Advisory Logo"
            style={{ width: "150px", borderRadius: "230px" }}
          />
        </div>

        <h5 className="mb-4" style={{ color: "#d4af37", fontWeight: "bold" }}>
          Admin Forgot Password
        </h5>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="email">
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>
          <br />
          <Button
            variant="warning"
            type="submit"
            className="w-100"
            disabled={loading}
            style={{ backgroundColor: "#d4af37", fontWeight: "bold" }}>
            {loading ? <Spinner animation="border" size="sm" /> : "Submit"}
          </Button>
        </Form>
      </div>
      {/* </Col>
      </Row> */}
    </Container>
  );
};

export default AdminForgotPassword;
